<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { titleClasses } from '../ui/Section'
import { Motion } from 'motion-v'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    imageClass?: HTMLAttributes['class']
    heroImage?: string
    buttonLabel?: string
    buttonLink?: string
    buttonClass?: HTMLAttributes['class']
    withGradient?: boolean
    withAction?: boolean
    title?: string
    subTitle?: string
    description?: string
    titleVariantSize?: keyof typeof titleClasses
  }>(),
  {
    class: undefined,
    imageClass: undefined,
    heroImage: '/assets/home-v4/hero.webp',
    buttonLabel: 'Daftar Gratis',
    buttonLink: 'https://app.kiriminaja.com',
    buttonClass: undefined,
    title: 'Hero Title',
    subTitle: undefined,
    description: undefined,
    withGradient: true,
    withAction: true,
    titleVariantSize: 'large'
  }
)
</script>

<template>
  <section
    :class="
      cn(
        'h-full items-center flex py-5 w-full bg-background dark:bg-surface-container-low',
        {
          relative: props.withGradient
        },
        props.class
      )
    "
  >
    <UiBgGrid v-if="props.withGradient" class="absolute inset-0" />
    <UiContainer
      class="grid lg:grid-cols-2 grid-cols-1 gap-6 lg:gap-10 items-center"
      :class="{
        relative: props.withGradient
      }"
    >
      <div
        :class="
          cn(
            'order-last w-full max-w-[70svw] lg:max-w-xl mx-auto lg:mr-0',
            props.imageClass
          )
        "
      >
        <NuxtImg
          alt="hero-image"
          :src="props.heroImage"
          fetchpriority="high"
          fetch-priority="high"
          width="576px"
          height="576px"
          :style="{
            viewTransitionName: 'hero-image'
          }"
        />
      </div>

      <slot>
        <div class="flex flex-col gap-3 lg:gap-7">
          <slot name="above-title" />
          <UiSectionTitle
            :variant-size="titleVariantSize"
            :title="props.title"
            :title-as="props.subTitle ? 'h2' : 'h1'"
            :sub-title="props.subTitle"
            sub-title-as="h1"
            :description="props.description"
            view-transition
          />

          <slot v-if="withAction" name="action">
            <Motion
              class="flex flex-col sm:items-center sm:flex-row pb-2"
              :initial="{ opacity: 0, translateY: 40 }"
              :while-in-view="{ opacity: 1, translateY: 0 }"
              :in-view-options="{ once: true }"
            >
              <UiButton
                :class="props.buttonClass"
                :to="$utm.utmUrl(props.buttonLink)"
                :label="props.buttonLabel"
              />
            </Motion>
          </slot>
        </div>
      </slot>
    </UiContainer>
  </section>
</template>
